import * as types from './actionTypes';
import { getFiltersBasedOnSearchTypeId, getSearchTypeIdBasedOnSearchTypeName } from '../api/searchFilterApi';

export function setFitlerListSuccess(filters) {
  return {
    type: types.SET_FILTER_LIST_SUCCESS,
    filters,
  };
}

export function setSearchTypeId(searchTypeId) {
  return {
    type: types.SET_SEARCH_TYPE_ID,
    searchTypeId,
  };
}

export function fetchFilterElements(searchTypeId) {
  return (dispatch) => {
    if (searchTypeId === -1) {
      dispatch(setFitlerListSuccess([]));
      return [];
    }

    return getFiltersBasedOnSearchTypeId(searchTypeId)
      .then((apiResponse) => {
        dispatch(setFitlerListSuccess(apiResponse.data.filterElements));
      })
      .catch((error) => {
        console.warn('error received while fetching filters based on searchTypeId', error);
      });
  };
}

export function fetchSearchTypeIdBasedOnSearchName(searchTypeName) {
  return (dispatch) => {
    return getSearchTypeIdBasedOnSearchTypeName(searchTypeName)
      .then((apiResponse) => {
        dispatch(setSearchTypeId(apiResponse.data));
      })
      .catch((error) => {
        console.warn('error received while fetching filters based on searchTypeId', error);
      });
  };
}
